<template>
    <div v-loading="loading" class="user-portfolio-additional" v-if="loading || showBlock">
        <div class="user-portfolio-additional__head">Дополнительная информация</div>
        <div v-if="showActivityBlock" class="user-portfolio-additional__activity">
            <div v-if="getUser.socialLiftType && socialLiftText" class="user-portfolio-additional__activity-item">
                <div class="user-portfolio-additional__activity-item-label">Социальный лифт:</div>
                <div class="user-portfolio-additional__activity-item-value">
                    {{ socialLiftText }}
                </div>
            </div>
            <div v-if="getUser.isSocial && getUser.socialActivity" class="user-portfolio-additional__activity-item">
                <div class="user-portfolio-additional__activity-item-label">Социальная активность:</div>
                <div class="user-portfolio-additional__activity-item-value">
                    {{ getUser.socialActivity }}
                </div>
            </div>
            <div
                v-if="getUser.isVolunteer && getUser.volunteerActivity"
                class="user-portfolio-additional__activity-item"
            >
                <div class="user-portfolio-additional__activity-item-label">Волонтерская деятельность:</div>
                <div class="user-portfolio-additional__activity-item-value">
                    {{ getUser.volunteerActivity }}
                </div>
            </div>
        </div>
        <div v-if="getUser.interests && getUser.interests.length" class="user-portfolio-additional__interests">
            <div class="user-portfolio-additional__interests-title">Интересы и увлечения</div>
            <div class="user-portfolio-additional__interests-chips">
                <div
                    v-for="(item, index) in getUser.interests"
                    class="user-portfolio-additional__interests-chip"
                    :key="index"
                >
                    {{ getInterestText(item) }}
                </div>
            </div>
        </div>
        <div v-if="centresCompetitionText" class="user-portfolio-additional__centres-competition">
            <span>{{ centresCompetitionText }}</span>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
    data: () => ({
        loading: false,
    }),
    computed: {
        ...mapGetters('newUsers', ['getUser']),
        ...mapGetters('data', ['getRegistryItems', 'getRegistryItemById']),

        showBlock() {
            const user = this.getUser;

            return this.showActivityBlock || this.centresCompetitionText || (user.interests && user.interests.length);
        },

        showActivityBlock() {
            const user = this.getUser;

            return (
                (user.isSocial && user.socialActivity) ||
                (user.isVolunteer && user.volunteerActivity) ||
                (user.socialLiftType && this.socialLiftText)
            );
        },

        socialLiftText() {
            return this.getRegistryItemById(this.getUser && this.getUser.socialLiftType);
        },

        centresCompetitionText() {
            return this.getRegistryItemById(this.getUser && this.getUser.centerCompetitionId);
        },
    },
    async created() {
        this.loading = true;

        await Promise.all([
            this.loadRegistryItems({ type: 'interests' }),
            this.loadRegistryItems({ type: 'social_lift' }),
            this.loadRegistryItems({ type: 'centres_competition' }),
        ]);

        this.loading = false;
    },
    methods: {
        ...mapActions('data', ['loadRegistryItems']),

        getInterestText(item) {
            return item.title || this.getRegistryItemById(item.rsvDataId);
        },
    },
};
</script>

<style scoped lang="scss">
@import '~@/styles/rem';
@import '~@/styles/variables';

.user-portfolio-additional {
    display: flex;
    flex-direction: column;
    gap: mrem(40);

    @include on-desktop {
        gap: rem(40);
    }

    &__head {
        color: $color-main-blue;
        font-weight: 700;
        font-size: mrem(21);

        @include on-desktop {
            font-size: rem(21);
        }
    }
    &__activity {
        display: flex;
        flex-direction: column;
        gap: mrem(40);

        @include on-desktop {
            gap: rem(16);
        }

        &-item {
            display: flex;
            flex-direction: column;
            gap: mrem(8);

            @include on-desktop {
                display: grid;
                grid-template-columns: rem(220) auto;
                gap: rem(16);
            }

            &-label {
                color: $color-main-grey;
                font-weight: 600;
                font-size: mrem(14);
                line-height: mrem(20);

                @include on-desktop {
                    font-size: rem(14);
                    line-height: rem(20);
                }
            }
            &-value {
                font-weight: 400;
                font-size: mrem(14);
                line-height: mrem(20);

                @include on-desktop {
                    font-size: rem(14);
                    line-height: rem(20);
                }
            }
        }
    }
    &__interests {
        &-title {
            font-weight: 700;
            font-size: mrem(18);
            line-height: mrem(24);
            margin-bottom: mrem(16);

            @include on-desktop {
                font-size: rem(18);
                line-height: rem(24);
                margin-bottom: rem(16);
            }
        }

        &-chips {
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            gap: mrem(16);

            @include on-desktop {
                gap: rem(16);
            }

            .user-portfolio-additional__interests-chip {
                color: $color-main-blue;
                font-weight: 400;
                display: flex;
                justify-content: center;
                align-items: center;
                border: 1px solid $color-main-blue;
                padding: mrem(8) mrem(18);
                gap: mrem(8);
                border-radius: mrem(120);

                @include on-desktop {
                    padding: rem(8) rem(18);
                    gap: rem(8);
                    border-radius: rem(120);
                }
            }
        }
    }

    &__centres-competition {
        display: flex;
        flex-direction: row;

        font-style: normal;
        font-weight: 600;
        font-size: mrem(14);
        line-height: mrem(20);
        gap: mrem(6);

        @include on-desktop {
            font-size: rem(14);
            line-height: rem(20);
            gap: rem(6);
        }

        &:before {
            flex: 0 1 auto;
            content: '';
            display: block;
            background: url('~@/assets/images/portfolio/award.svg') no-repeat center center;
            background-size: cover;
            width: mrem(24);
            min-width: mrem(24);
            height: mrem(24);

            @include on-desktop {
                width: rem(24);
                min-width: rem(24);
                height: rem(24);
            }
        }
    }
}
</style>
